<template>
  <wrap-container>
    <help-title title="CBU/Alias" />

    <help-list-container>
      <help-list-item tituloLista="¿Cómo obtener mi CBU/Alias?">
        Para obtener tu CBU ingresá a
        <a id="contactForm" href="https://www.bbva.com.ar">Banca Online</a> con
        tu DNI, Usuario y Clave Digital.<br />
        - Desplegá el menú <strong>"Voy a"</strong> de la cuenta a consultar y
        seleccioná <strong>"CBU/ALIAS"</strong>.
      </help-list-item>

      <help-list-item tituloLista="Desde la App:">
        - App BBVA con tu DNI, usuario y Clave Digital.<br />
        - Hacé clic sobre la cuenta a consultar.<br />
        - Ingresá al menú <strong>"Más"</strong> y luego
        <strong>"Gestionar CBU-Alias"</strong>.
      </help-list-item>

      <help-list-item tituloLista="Desde el cajero:">
        También podés obtenerlo mediante cajeros de la Red Banelco con tu
        Tarjeta de Débito o en nuestras Terminales de Autoservicio.<br />
        - Ingresá a la opción
        <strong>"Consultas - Clave Bancaria Uniforme"</strong>.
      </help-list-item>

      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <p id="contactForm" @click="contacto">Quiero que me contacten</p>
        <div v-if="show">
          <br />
          <formulario-contacto />
        </div>
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import FormularioContacto from "@/views/segments/subSegments/FormularioContacto.vue";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    FormularioContacto
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    contacto: function() {
      this.show = true;
    }
  }
};
</script>

<style>
#contactForm {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 15px;
  color: #1973b8;
  text-decoration: none;
  cursor: pointer;
}
</style>
